declare let vivaparkTranslations;
declare let translations;

export const translate = (key: string) => {
    if (typeof vivaparkTranslations != "undefined" && vivaparkTranslations[key]){
        return vivaparkTranslations[key];
    }else if(typeof translations != "undefined" && translations[key]){
        return translations[key];
    }else{
        return key;
    }
}

